import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

function Employee() {
  const [editId, setEditId] = useState(null);
  const [editForm, setEditForm] = useState({});
  const [employeedata, setEmployeedata] = useState([]);

  useEffect(() => {
    const data = localStorage.getItem("users");
    if (data) {
      try {
        setEmployeedata(JSON.parse(data));
      } catch (err) {
        console.error("Failed to parse employee data from localStorage", err);
        setEmployeedata([]);
      }
    } else {
      setEmployeedata([]);
    }
  }, []);

  // Edit Handlers
  const handleEdit = (employee) => {
    setEditId(employee._id);
    setEditForm({ ...employee });
  };

  const handleCancel = () => {
    setEditId(null);
    setEditForm({});
  };

  const handleSave = (id) => {
    const updated = employeedata.map((e) =>
      e._id === id ? { ...e, ...editForm } : e
    );

    setEmployeedata(updated);
    localStorage.setItem("users", JSON.stringify(updated));

    setEditId(null);
    setEditForm({});
  };

  // Delete Handler
  const handleDelete = (id) => {
    if (!window.confirm("Delete this employee?")) return;

    const updated = employeedata.filter((e) => e._id !== id);
    setEmployeedata(updated);
    localStorage.setItem("users", JSON.stringify(updated));
  };

  // Helper function to safely format dates
  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const parsed = new Date(dateString);
    return isNaN(parsed.getTime()) ? dateString : parsed.toLocaleDateString();
  };

  const fields = [
    "name",
    "phone",
    "age",
    "dob",
    "address",
    "joining",
    "role",
    "salary",
    "paidLeave",
    "halfDay",
    "aadhaar",
    "pan",
    "religion",
  ];

  return (
    <div>
      <div className="page-header-tap">
        <h3>Employee</h3>

        <div>
          <Link to="/">
            <button
              className="addbtn"
              style={{ width: "max-content", margin: "0px 10px" }}
            >
              + Add Employee
            </button>
          </Link>
        </div>
      </div>

      <div className="table-div" style={{ marginTop: "20px" }}>
        <div className="table-header">
          <h5>Employee list</h5>
        </div>

        <div className="table">
          <table>
            <thead>
              <tr>
                <th>Name</th>
                <th>Phone</th>
                <th>Age</th>
                <th>DOB</th>
                <th>Address</th>
                <th>Joining</th>
                <th>Role</th>
                <th>Salary</th>
                <th>Paid Leave</th>
                <th>Half Day</th>
                <th>Aadhaar</th>
                <th>PAN</th>
                <th>Religion</th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody>
              {employeedata.length === 0 ? (
                <tr>
                  <td colSpan={fields.length + 1} style={{ textAlign: "center" }}>
                    No employee records found.
                  </td>
                </tr>
              ) : (
                employeedata.map((e) => (
                  <tr key={e._id}>
                    {fields.map((field) => (
                      <td key={field}>
                        {editId === e._id ? (
                          <input
                            type={
                              ["dob", "joining"].includes(field)
                                ? "date"
                                : "text"
                            }
                            value={editForm[field] ?? ""}
                            onChange={(ev) =>
                              setEditForm({
                                ...editForm,
                                [field]: ev.target.value,
                              })
                            }
                          />
                        ) : field === "salary" ? (
                          e[field] ? `₹ ${e[field]}` : "-"
                        ) : field === "dob" || field === "joining" ? (
                          formatDate(e[field])
                        ) : (
                          e[field] ?? "-"
                        )}
                      </td>
                    ))}

                    <td>
                      {editId === e._id ? (
                        <>
                          <button
                            onClick={() => handleSave(e._id)}
                            className="statusbox green-bg"
                          >
                            Save
                          </button>
                          <button
                            onClick={handleCancel}
                            className="statusbox red-bg"
                          >
                            Cancel
                          </button>
                        </>
                      ) : (
                        <>
                          <button
                            onClick={() => handleEdit(e)}
                            className="statusbox green-bg"
                          >
                            Edit
                          </button>
                          <button
                            onClick={() => handleDelete(e._id)}
                            className="statusbox red-bg"
                          >
                            Delete
                          </button>
                        </>
                      )}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default Employee;